// ─────────────────────────────────────────────────────────────────────────────
// Research categories — catalog subdivided by COMPOUND CLASS / FAMILY only.
//
// IMPORTANT: these labels are nomenclature (what each molecule *is*), never a
// statement of effect, benefit, or use. Do not add claim-style names here
// (e.g. "Weight Loss", "Healing", "Anti-Aging"). Keep it to compound class.
//
// `members` are product slugs. To re-bucket the catalog, just move a slug.
// `homepage: true` marks the categories surfaced in the homepage tile grid
// (the first is the large hero tile); every category shows on the shop page.
// ─────────────────────────────────────────────────────────────────────────────
export const CATEGORIES = [
  {
    slug: 'secretagogues',
    name: 'GH Secretagogues',
    blurb: 'CJC-1295 · Ipamorelin · Sermorelin · GHRP',
    members: ['cjc-1295', 'cjc-1295-ipamorelin', 'ipamorelin', 'tesamorelin', 'sermorelin', 'ghrp-2', 'ghrp-6', 'hexarelin', 'mk-677'],
    from: '#2BA6E8', to: '#0E5C93', homepage: true,
  },
  {
    slug: 'glp-1',
    name: 'GLP-1 & Metabolic',
    blurb: 'Semaglutide · Tirzepatide · RETA · GLP-3 · Cagrilintide',
    members: ['semaglutide', 'tirzepatide', 'reta', 'glp-3', 'cagrilintide', '5-amino-1mq'],
    from: '#19C08A', to: '#0A6E50', homepage: true,
  },
  {
    slug: 'thymosin-bpc',
    name: 'Thymosin & BPC',
    blurb: 'TB-500 · BPC-157 · Thymosin α-1 · KPV',
    members: ['tb-500', 'bpc-157', 'thymosin-alpha-1', 'kpv'],
    from: '#9C6CE6', to: '#5A2EA6', homepage: true,
  },
  {
    slug: 'melanocortins',
    name: 'Melanocortins',
    blurb: 'Melanotan I & II · PT-141',
    members: ['melanotan-ii', 'melanotan-i', 'pt-141', 'pt-141-spray'],
    from: '#F4A03C', to: '#BD500F', homepage: true,
  },
  {
    slug: 'cofactors',
    name: 'Cellular & Cofactors',
    blurb: 'NAD+ · GHK-Cu · Glutathione · MOTS-c · SNAP-8',
    members: ['ghk-cu', 'ghk-cu-spray', 'nad-plus', 'nad-plus-spray', 'glutathione', 'mots-c', 'snap-8'],
    from: '#F4655F', to: '#AE2C2A', homepage: true,
  },
  {
    slug: 'blends',
    name: 'Peptide Blends',
    blurb: 'GLOW · KLOW · Wolverine (BPC/TB)',
    members: ['glow', 'klow', 'wolverine'],
    from: '#EC6AA6', to: '#B23574', homepage: true,
  },
  {
    slug: 'gh-fragments',
    name: 'GH Fragments & Factors',
    blurb: 'AOD-9604 · IGF-1 LR3 · HGH Frag 176-191',
    members: ['aod-9604', 'igf-1-lr3', 'hgh-frag-176-191'],
    from: '#2FB6C0', to: '#0E6E78', homepage: true,
  },
  {
    slug: 'circadian',
    name: 'Circadian Peptides',
    blurb: 'DSIP · Epithalon',
    members: ['dsip', 'epithalon'],
    from: '#6E5AB0', to: '#3B2C74',
  },
  {
    slug: 'supplies',
    name: 'Research Supplies',
    blurb: 'Bacteriostatic water · consumables',
    members: ['amino-h2o'],
    from: '#5A93C8', to: '#2C5A86',
  },
  {
    slug: 'nootropics',
    name: 'Nootropic Peptides',
    blurb: 'Semax · Selank · N-Acetyl variants',
    members: ['semax', 'selank', 'n-acetyl-semax-amidate', 'n-acetyl-selank-amidate'],
    from: '#6C7BE6', to: '#2E3AA6',
  },
  {
    slug: 'kiss-gonad',
    name: 'Kisspeptin & Gonadorelin',
    blurb: 'Kisspeptin-10 · Gonadorelin',
    members: ['kisspeptin-10', 'gonadorelin'],
    from: '#E069A8', to: '#A62E73',
  },
];

// Categories featured in the homepage tile grid (first entry = hero tile).
export const HOMEPAGE_CATEGORIES = CATEGORIES.filter((c) => c.homepage);

// Look up the category definition for a product slug (used for shop labels +
// filtering). Returns undefined if the product hasn't been bucketed yet.
export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const categoryForProduct = (productSlug) =>
  CATEGORIES.find((c) => c.members.includes(productSlug));
